// Script to refresh Course Information and Instructors blocks when metabox data is saved
jQuery(document).ready(function($) {
    // Listen for the metabox save events for course and membership

    $(document).on('llms_metabox_after_save_lifterlms-course-options llms_metabox_after_save_lifterlms-membership', function(event, post_id) {
		debugger;
        // Check if we're in the block editor
        if (wp.data && wp.data.dispatch && wp.data.select('core/editor')) {
            // Get the current post type
            const postType = wp.data.select('core/editor').getCurrentPostType();

            // Only proceed for course and membership post types
            if (postType === 'course' || postType === 'llms_membership') {
                // Force a re-render of the Course Information and Instructors blocks
                const blocks = wp.data.select('core/block-editor').getBlocks();

                blocks.forEach(function(block) {
                    if (block.name === 'llms/course-information' || block.name === 'llms/instructors') {
                        // Update the block attributes to force a re-render
                        wp.data.dispatch('core/block-editor').updateBlockAttributes(block.clientId, { ...block.attributes });
                    }
                });
            }
        }
    });
});
